import { useMemo } from 'react';

import { useActorRef } from '@xstate5/react';

import { useFetchCustomerActor, useFetchSessionActor } from './actors';
import { authMachine } from './auth-machine';

import type { ActorRefFrom } from 'xstate5';

export type AuthMachineRefType = ActorRefFrom<typeof authMachine>;

export const useInitAuthMachine = () => {
  const fetchCustomer = useFetchCustomerActor();
  const fetchSession = useFetchSessionActor();

  // ─── Derived ───────────────────────────────────────────────────────────────

  const providedAuthMachine = useMemo(() => {
    return authMachine.provide({ actors: { fetchCustomer, fetchSession } });
  }, [fetchCustomer, fetchSession]);

  return useActorRef(providedAuthMachine);
};
